
import React from "react";
import withFosRouter from "../../FosRouter/withFosRouting";
import styled from "@emotion/styled";

const Block = styled.div`
	box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.05);
`;
const ContactComponent = (props) => {
    return (
        <Block className="flex flex-wrap justify-saround p-3 bg-white border-radius-default mx-4" >
            <img src="/assets/img/front/lloret-north-team-lg.jpg" className="width-100" width="425" />
            <div className="mt-3"><a href={props.r('content_contact')} className="text-center btn btn-secondary font-w600 font-130 px-3" tabIndex="0">{props.t('contactus')}</a></div>
        </Block>
    )
}

export const Contact = withFosRouter(ContactComponent);